import Vue from 'vue'
import Router from 'vue-router'

import Index from './views/Index'
import forbidden from './views/Forbidden'


Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: "login",
      component: () => import('./views/Login.vue')
    },
    { path: '/home', component: Index },
    { path: '/forbidden', component: forbidden },
    {
      path: '*',
      redirect: "/"
    }
  ]
})
